module.exports = __webpack_public_path__ + "img/default-desktop-arabic-no-content.66f71c91.png";